import { createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./services/protectedRoutes";
import HomePage from "./pages/home";
import FaqsPage from "./pages/faqs";
import ApiKeysPage from "./pages/api-keys";
import ManageContentPage from "./pages/manage-content";

export const routes = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <HomePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/faqs",
    element: (
      <ProtectedRoute>
        <FaqsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/api-keys",
    element: (
      <ProtectedRoute>
        <ApiKeysPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/manage-content",
    element: (
      <ProtectedRoute>
        <ManageContentPage />
      </ProtectedRoute>
    ),
  },
]);
